import { render, staticRenderFns } from "./productItemList.vue?vue&type=template&id=30c48fe4&scoped=true&"
import script from "./productItemList.vue?vue&type=script&lang=js&"
export * from "./productItemList.vue?vue&type=script&lang=js&"
import style0 from "./productItemList.vue?vue&type=style&index=0&id=30c48fe4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c48fe4",
  null
  
)

export default component.exports